namespace $.$$ {
	export class $shm_showcase_component extends $.$shm_showcase_component {

		entry() { return $shm_showcase_entries.find( entry => entry.id === this.entry_id() )! }
		component_title() { return this.entry().title }

		@ $mol_mem
		demo_content() {
			switch( this.entry_id() ) {
				case 'shm_tree': return [ new this.$.$shm_showcase_demo_tree() ]
				case 'shm_paginator': return [ new this.$.$shm_showcase_demo_paginator() ]
				case 'shm_echarts': return [ new this.$.$shm_showcase_demo_echarts() ]
				case 'shm_file_drop': return [ new this.$.$shm_showcase_demo_file_drop() ]
				case 'shm_period': return [ new this.$.$shm_showcase_demo_period() ]
				case 'shm_check_list': return [ new this.$.$shm_showcase_demo_check_list() ]
				case 'shm_button_copy': return [ new this.$.$shm_showcase_demo_button_copy() ]
				case 'shm_dotsloader': return [ new this.$.$shm_showcase_demo_dotsloader() ]
				case 'shm_list_page': return [ new this.$.$shm_showcase_demo_list_page() ]
				case 'text': return [ new this.$.$mol_text_demo() ]
				case 'text_code': return [ this.Code_demo() ]
				case 'speck': return [ new this.$.$mol_speck_demo() ]
				case 'portion': return [ new this.$.$mol_portion_demo() ]
				case 'calendar': return [ new this.$.$mol_calendar_demo_simple() ]
				case 'avatar': return [ new this.$.$mol_avatar_demo() ]
				case 'grid': return [ new this.$.$mol_grid_demo() ]
				case 'chart': return [ new this.$.$mol_chart_demo_simple() ]
				case 'frame': return [ new this.$.$mol_frame_demo() ]
				case 'book2': return [ new this.$.$mol_book2_demo() ]
				case 'page': return [ new this.$.$mol_page_demo() ]
				case 'scroll': return [ new this.$.$mol_scroll_demo() ]
				case 'list': return [ new this.$.$mol_list_demo() ]
				case 'bar': return [ new this.$.$mol_bar_demo() ]
				case 'gallery': return [ new this.$.$mol_gallery_demo() ]
				case 'labeler': return [ new this.$.$mol_labeler_demo() ]
				case 'stack': return [ new this.$.$mol_stack_demo() ]
				case 'pop': return [ new this.$.$mol_pop_demo() ]
				case 'pop_over': return [ new this.$.$mol_pop_over_demo() ]
				case 'float': return [ new this.$.$mol_float_demo() ]
				case 'section': return [ new this.$.$mol_section_demo() ]
				case 'card': return [ new this.$.$mol_card_demo() ]
				case 'deck': return [ new this.$.$mol_deck_demo() ]
				case 'expander': return [ new this.$.$mol_expander_demo() ]
				case 'toolbar': return [ new this.$.$mol_toolbar_demo() ]
				case 'string': return [ new this.$.$mol_string_demo() ]
				case 'number': return [ new this.$.$mol_number_demo() ]
				case 'textarea': return [ new this.$.$mol_textarea_demo() ]
				case 'check_box': return [ new this.$.$mol_check_box_demo() ]
				case 'format': return [ new this.$.$mol_format_demo() ]
				case 'paginator': return [ new this.$.$mol_paginator_demo() ]
				case 'search': return [ new this.$.$mol_search_demo() ]
				case 'check_list': return [ new this.$.$mol_check_list_demo() ]
				case 'switch': return [ new this.$.$mol_switch_demo() ]
				case 'select': return [ new this.$.$mol_select_demo_colors() ]
				case 'select_list': return [ new this.$.$mol_select_list_demo() ]
				case 'date': return [ new this.$.$mol_date_demo() ]
				case 'pick_time': return [ new this.$.$mol_pick_time_demo() ]
				case 'pick': return [ new this.$.$mol_pick_demo() ]
				case 'link': return [ new this.$.$mol_link_demo() ]
				case 'button': return [ new this.$.$mol_button_demo() ]
				case 'button_share': return [ new this.$.$mol_button_share_demo() ]
				case 'lights_toggle': return [ new this.$.$mol_lights_demo() ]
				case 'form': return [ new this.$.$mol_form_demo() ]
				case 'book2_catalog': return [ new this.$.$mol_book2_catalog_demo() ]
				case 'map_yandex': return [ new this.$.$mol_map_yandex_demo() ]
				case 'video_player': return [ new this.$.$mol_video_player_demo() ]
				case 'speech': return [ new this.$.$mol_speech_demo() ]
				case 'theme_auto': return [ new this.$.$mol_theme_demo() ]
				case 'drag': return [ new this.$.$mol_drag_demo() ]
			}
			return []
		}
	}
}
